module.exports = __webpack_public_path__ + "img/fiat.adb7b58b.png";